<template>
	<div class="page-mouth">
		<div class="content">
			<time-num></time-num>
			<!-- <div class="topTitle">
        方法{{ accordWith[timuIndex].answers }}:&nbsp;&nbsp;&nbsp;{{
          accordWith[timuIndex].name
        }}
      </div> -->
			<div class="body-box" v-show="accordWith[timuIndex].fileList.length > 0">
				<van-swipe ref="swiper" class="my-swipe" :autoplay="3000" indicator-color="white">
					<van-swipe-item v-for="(item, index) in accordWith[timuIndex].fileList" :key="index">
						<img @click="handleImg(item.filePath)" :src="item.filePath" alt />
					</van-swipe-item>
				</van-swipe>
				<div class="rightChanges" v-show="accordWith[timuIndex].fileList.length > 1"
					@click="handleNextClick(true)">
					<van-icon name="arrow-left" color="#fff" size="19" />
				</div>
				<div class="rightChange" v-show="accordWith[timuIndex].fileList.length > 1"
					@click="handleNextClick(false)">
					<van-icon name="arrow" color="#fff" size="19" />
				</div>
			</div>
			<div class="choose-box" v-show="accordWith[timuIndex].flag">
				<div class="choose-text">
					{{ accordWith[timuIndex].title }}
					({{ accordWith[timuIndex].typeName }})
				</div>
				<div v-for="(item, index) in accordWith[timuIndex].optionList" :class="item.flag ? 'choose-active' : ''"
					class="choose-list" :key="index" @click="handleChooseClick(item, index)">
					<p>{{ item.value }}</p>
					<div>{{ item.content }}</div>
				</div>
			</div>
			<div class="choose-no" :class="accordWith[timuIndex].fileList.length === 0 ? 'choose-yes' : ''"
				v-show="!accordWith[timuIndex].flag">
				<div>您选择的此项检查方法</div>
				<div>对该病例的诊断意义不大</div>
			</div>
		</div>

		<div class="footer">
			<div class="btn">
				<!-- <div class="nextquestionactive" @click="$router.replace('/treat/clinical')">
					<img class="next1" src="./../../assets/home/previous.png"></img>上一题
				</div> -->
				<div class="return" @click="handleSubmit">
					<img src="./../../assets/treat/submit.png" alt />
					<div class="text">{{ footerText }}</div>
				</div>
			</div>
		</div>
		<div class="page-mouthModal" v-if="visible">
			<div class="content">
				<div class="title">提示！</div>
				<div class="text">
					<p>请至少选择一个检查方法,</p>
					<p>请再仔细审查题目。</p>
				</div>
				<div class="footers">
					<button @click="handleOk">确定</button>
				</div>
			</div>
		</div>
		<van-popup v-model="isShow" className="dialogImg">
			<div class="imgAmplify">
				<img :src="activeImg" alt="" />
			</div>
		</van-popup>
		<mi-xin></mi-xin>
	</div>
</template>

<script>
	import mouthModal from "./mouthModal.vue";
	import {
		mapState,
		mapMutations
	} from "vuex";
	import MiXin from "../mixins/index";
	import TimeNum from "../mixins/timeNum";
	import {
		submitExamCommitSingerAnswer
	} from "../../api/system/exam";
	export default {
		components: {
			MiXin,
			mouthModal,
			TimeNum,
		},
		name: "mouth",
		data() {
			return {
				visible: false,
				timuIndex: 0,
				fileList: [],
				clinicaltwoObj: [],
				accordWith: [],
				chooseIndex: -1,
				clientHeightFlag: true,
				preposeList: [],
				footerText: "提交并进入下一题",
				isShow: false,
				activeImg: null,
				radioIndex: null,
			};
		},
		computed: {
			...mapState("visualExamination", [
				"mouthModalFlag",
				"selectPosition",
				"selectPositionObj",
				"treatmentList",
				"detail6",
				//步骤二
				"detail",
				//步骤三
				"detailsz2",
				//步骤四
				"detail3",
				"detailstepPre3",
				//步骤五
				"detail4",
				//步骤六
				"detail5",
				"treatmentEcho",
			]),
			...mapState("microscope", ["examDetailId"]),
		},
		watch: {
			//选择项
			selectPosition: {
				handler(val) {
					this.submitObj = val;
				},
				deep: true,
			},
		},
		created() {
			const obj = this.treatmentList;
			this.clinicaltwoObj = obj.step4Questions;
			console.log("clinicaltwoObj", this.clinicaltwoObj);
			this.clinicaltwoObj.map((item) => {
				item.optionList.map((v) => {
					v.flag = false;
				});
			});
			this.initData();
		},
		mounted() {
			if (document.documentElement.clientHeight >= 1038) {
				this.clientHeightFlag = false;
			} else {
				this.clientHeightFlag = true;
			}
		},
		methods: {
			...mapMutations("visualExamination", ["VISUAL_EXAMINATION"]),
			//初始化数据处理
			initData() {
				this.accordWith = this.clinicaltwoObj;
				this.accordWith.map((v) => {
					v.flag = true;
				});
			},

			//选中
			handleChooseClick(item, index) {
				if (
					this.accordWith[this.timuIndex].type === "2" ||
					this.accordWith[this.timuIndex].type === "3"
				) {
					this.accordWith[this.timuIndex].optionList.map((v) => {
						if (item.id === v.id) {
							v.flag = !v.flag;
						}
					});
				} else {
					this.accordWith[this.timuIndex].optionList.forEach(
						(item) => (item.flag = false)
					);
					this.accordWith[this.timuIndex].optionList[index].flag = true;
				}
				this.$forceUpdate();
			},

			//关闭弹框
			handleOk() {
				this.visible = false;
			},

			//提交
			handleSubmit() {
				let idList = [];
				const arr = [];
				if (this.accordWith[this.timuIndex].optionList.length !== 0) {
					this.accordWith[this.timuIndex].optionList.forEach((item) => {
						if (item.flag) {
							idList.push(item.value);
							arr.push(item);
						}
					});
				}
				if (
					this.accordWith[this.timuIndex].type === "3" &&
					this.accordWith[this.timuIndex].optionList.length !== 0
				) {
					if (arr.length < 1) {
						this.visible = true;
					} else {
						this.commit(idList);
					}
				} else if (this.accordWith[this.timuIndex].optionList.length === 0) {
					this.commit();
				} else if (
					this.accordWith[this.timuIndex].type === "1" &&
					this.accordWith[this.timuIndex].optionList.length !== 0
				) {
					if (arr.length !== 1) {
						this.visible = true;
					} else {
						this.commit(idList);
					}
				} else if (
					this.accordWith[this.timuIndex].type === "2" &&
					this.accordWith[this.timuIndex].optionList.length !== 0
				) {
					if (arr.length < 2) {
						this.visible = true;
					} else {
						this.commit(idList);
					}
				}
			},

			commit(arr) {
				let list = [];
				if (arr) {
					const val = arr.join(",");
					list = {
						answers: val,
						questionId: this.accordWith[this.timuIndex].id,
					};
					this.VISUAL_EXAMINATION({
						key: "detail3",
						value: list
					});
				}
				if (this.timuIndex < this.accordWith.length - 1) {
					this.timuIndex++;
				} else if (this.timuIndex === this.accordWith.length - 1) {


					let newArr = [
						...this.detail,
						...this.detailsz2,
						...this.detail3,
						...this.detailstepPre3,
						...this.detail4,
						...this.detail5,
					];
					const parmes = {
						paperId: this.treatmentList.id,
						details: newArr,
					};
					submitExamCommitSingerAnswer({
						backendAnswers: JSON.stringify(parmes),
						paperId: this.treatmentList.id,
						questionId: '-8',
						answers: JSON.stringify({
							detail: this.detail,
							detailsz2: this.detailsz2,
							detail3: this.detail3,
							detailstepPre3: this.detailstepPre3,
							detail4: this.detail4,
							detail5: this.detail5,
							treatmentEcho: this.treatmentEcho
						}),
						extractDetailId: this.examDetailId,
					}).then((response) => {
						const obj = {
							stepTwo: true,
							stepThree: true,
							stepFour: true,
							stepFive: true,
							stepSix: false,
						};
						this.VISUAL_EXAMINATION({
							key: "contentObj",
							value: obj
						});
						this.VISUAL_EXAMINATION({
							key: "overIndex",
							value: 4
						});
						this.$router.replace({
							path: "/treat/medicalrecord",
							query: {
								num: 4.1
							},
						});
					});
				}
				if (this.timuIndex === this.accordWith.length - 1) {
					this.footerText = "提交";
				}
			},

			//轮播切换
			handleNextClick(v) {
				if (v) {
					this.$refs.swiper.prev();
				} else {
					this.$refs.swiper.next();
				}
			},

			// 选中看大图
			handleImg(url) {
				this.activeImg = url;
				this.isShow = true;
			},
		},
	};
</script>

<style lang="less" scoped>
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	.page-mouth {
		width: 100%;
		min-height: 100vh;
		background-image: url("./../../assets/home/xwjBg.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		align-items: center;

		.content {
			flex: 1;
			width: 100%;
			padding: 0 45px;

			.time-num {
				padding: 10px 0;
			}

			.topTitle {
				text-align: center;
				margin-bottom: 27px;
				margin-top: 31px;
				font-size: 35px;
				font-weight: 500;
				color: #ffffff;
			}
		}

		.body-box {
			width: 100%;
			height: 545px;
			background: rgba(255, 255, 255, 0.3);
			box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
			border: 2px solid #ffffff;
			padding: 19px 23px;
			border-radius: 60px;
			position: relative;

			.my-swipe,
			.van-swipe-item,
			img {
				width: 100%;
				height: 100%;
				border-radius: 48px;
			}
		}

		.rightChanges {
			width: 72px;
			height: 72px;
			opacity: 0.7;
			border-radius: 50%;
			background: #ab3b91;
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			top: 240px;
			left: 27px;
		}

		.rightChange {
			width: 72px;
			height: 72px;
			opacity: 0.7;
			border-radius: 50%;
			background: #ab3b91;
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			top: 240px;
			right: 27px;
		}

		::v-deep .van-swipe__indicator {
			width: 18px;
			height: 18px;
			background: #d2d2d2;
		}

		.choose-no {
			margin-top: 46px;
			background: rgba(255, 255, 255, 0.5);
			box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
			border: 2px solid #ffffff;
			border-radius: 60px;
			padding: 40px 45px 40px 45px;
			width: 100%;
			height: 652px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			font-size: 45px;
			font-family: HarmonyOS Sans SC;
			font-weight: bold;
			color: #ab3b91;
		}

		.choose-yes {
			margin-top: 246px;
		}

		.choose-box {
			margin-top: 45px;
			width: 100%;
			height: auto;
			background: rgba(255, 255, 255, 0.5);
			box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
			border: 2px solid #ffffff;
			border-radius: 60px;
			padding: 40px 45px 40px 45px;
			margin-bottom: 180px;

			.choose-text {
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #333333;
				line-height: 50px;
				white-space: normal;
			}

			.choose-list {
				width: 100%;
				height: auto;
				background: #ffffff;
				box-shadow: 2px 3px 5px 0px rgba(14, 89, 145, 0.11);
				border-radius: 40px;
				margin-top: 20px;
				font-size: 25px;
				font-family: HarmonyOS Sans SC;
				font-weight: 400;
				color: #4d4d4d;
				display: flex;
				align-items: center;
				padding: 28px 61px;

				p {
					position: relative;
					margin-right: 19px;
				}

				p::before {
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					left: 39px;
					content: "";
					width: 2px;
					height: 38px;
					background: #cccccc;
				}

				div {
					margin-left: 35px;
				}
			}

			.choose-active {
				box-shadow: 2px 3px 5px 0px rgba(14, 89, 145, 0.11);
				background: #ab3b91;
				color: #fff;
			}

			.choose-active>p::before {
				background: #fff;
			}
		}

		.footer {
			position: fixed;
			bottom: 0;
			width: 100%;
			height: 183px;
		}

		.btnActive {
			position: absolute;
			left: 0;
			bottom: 0;
		}

		.btn {
			width: 100%;
			height: 183px;
			background: linear-gradient(0deg, #ffffff, #e9f4f2);
			border-radius: 60px 60px 0px 0px;

			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-around;

			.return {
				width: 426px;
				height: 87px;
				background: linear-gradient(132.74deg,
						rgba(0, 187, 177, 1) 0%,
						rgba(0, 86, 140, 1) 74.31%,
						rgba(171, 59, 127, 1) 100%);
				border: 1px solid #ffffff;
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
				display: flex;
				border-radius: 50px;
				align-items: center;
				justify-content: center;
				font-size: 35px;
				font-weight: 500;
				color: #ffffff;
				margin-left: 25px;
				padding: 27px 31px;

				img {
					width: 36px;
					height: 33px;
					margin-right: 10px;
				}
			}
		}

		.page-mouthModal {
			width: 100%;
			min-height: 100vh;
			position: absolute;
			left: 0;
			top: 0;
			background: rgba(#fff, 0.8);
			padding: 0 40px;
			display: flex;
			align-items: center;
			z-index: 1;

			.content {
				width: 100%;
				height: 642px;
				z-index: 999;
				background: #ffffff;
				background: rgba(255, 255, 255, 0.9);
				border: 2px solid #ffffff;
				border-radius: 60px;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				padding-top: 90px;
				padding-bottom: 77px;
			}

			.title {
				font-size: 65px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #ab3b91;
			}

			.text {
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #333333;
				line-height: 60px;
				margin-top: 80px;
				text-align: center;
			}

			.footers {
				margin-top: 110px;

				button {
					width: 262px;
					height: 79px;
					background: linear-gradient(132.74deg,
							rgba(0, 187, 177, 1) 0%,
							rgba(0, 86, 140, 1) 74.31%,
							rgba(171, 59, 127, 1) 100%);
					border: 1px solid #ffffff;
					box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
					text-align: center;
					font-size: 35px;
					font-family: HarmonyOS Sans SC;
					font-weight: 500;
					color: #ffffff;
					line-height: 60px;
					letter-spacing: 2px;
					border-radius: 40px;
				}

				button:nth-child(2) {
					margin-left: 42px;
				}
			}
		}
	}

	::v-deep .van-popup {
		border-radius: 0;
		width: 98%;
		background: none;

		.imgAmplify {
			width: 92%;
			margin: 0 auto;

			img {
				width: 100%;
			}
		}
	}

	.nextquestionactive {
		background: linear-gradient(138.51deg, rgba(0, 187, 177, 1) 0%, rgba(0, 80, 137, 1) 79.86%, rgba(171, 59, 127, 1) 100%);
		font-size: 32px;
		color: rgba(255, 255, 255, 1);
		display: flex;
		align-items: center;
		justify-content: center;
		width: 214px;
		height: 88px;
		border-radius: 100px;
	}

	.next1 {
		width: 28px;
		height: 24px;
		margin-right: 16px;
	}
</style>